import { render } from "./forgotRegister.vue?vue&type=template&id=510a717f"
import script from "./forgotRegister.vue?vue&type=script&lang=js"
export * from "./forgotRegister.vue?vue&type=script&lang=js"

import exportComponent from "C:\\inetpub\\wwwroot\\frontend\\employer-frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__